import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Tooltip } from '@material-ui/core';
import { VpnKey } from '@material-ui/icons';

import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { WithApp } from 'contexts/appContext';
import { wsUpdate } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles(styles);


export default WithApp(function ButtonResetPassword(props) {
  const classes = useStyles();
  const { userId, nombre, disabled } = props;

  const [notify, showNotify] = useToasty();
  const [alert, setAlert] = useState(null);
  const [procesando, setProcesando] = useState(false);

  const hideAlert = () => setAlert(null);

  function confirmar() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Restablecer la contraseña?"
        onConfirm={() => {
          hideAlert();
          resetear();
        }}
        onCancel={hideAlert}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {nombre ? `${nombre} ` : ''}
        volverá a tener la contraseña por defecto y se le va a exigir cambiarla al
        iniciar sesión. Sus sesiones abiertas se cerrarán.
      </SweetAlert>
    );
  }

  async function resetear() {
    setProcesando(true);
    let response = await wsUpdate(`oauth/user/${userId}/reset-password`, {});
    setProcesando(false);

    if (response.success) {
      setAlert(
        <SweetAlert
          success
          style={{ display: 'block', marginTop: '-100px' }}
          title="Contraseña restablecida"
          onConfirm={hideAlert}
          confirmBtnCssClass={classes.button + ' ' + classes.success}
          confirmBtnText="Aceptar"
        >
          Nueva contraseña: <b>{response.data?.password}</b>
        </SweetAlert>
      );
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      <Tooltip title="Restablecer contraseña">
        <span>
          <Button
            justIcon
            round
            simple
            color="warning"
            onClick={confirmar}
            disabled={procesando || !userId || disabled === true}
          >
            <VpnKey />
          </Button>
        </span>
      </Tooltip>
    </Fragment>
  );
});
